module.exports = __webpack_public_path__ + "static/logo-a06deedd4bb84eee7e94d9d01344f16f.png";